module.exports = __webpack_public_path__ + "static/media/lock_icon.ac8c2507.svg";